export default function HourGlass({ className }: { className?: string }) {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.3987 9.21375L7.042 6L10.3987 2.78625C10.4006 2.7841 10.4027 2.78207 10.4048 2.78016C10.5096 2.67527 10.581 2.54166 10.6099 2.39622C10.6388 2.25078 10.624 2.10004 10.5672 1.96303C10.5105 1.82603 10.4144 1.70892 10.2911 1.62651C10.1679 1.54409 10.0229 1.50007 9.87465 1.5H3.12465C2.97637 1.50007 2.83143 1.54409 2.70816 1.62651C2.58488 1.70892 2.48881 1.82603 2.43207 1.96303C2.37533 2.10004 2.36048 2.25078 2.38939 2.39622C2.4183 2.54166 2.48968 2.67527 2.5945 2.78016C2.59664 2.78207 2.59868 2.7841 2.60059 2.78625L5.95731 6L2.60059 9.21375C2.59868 9.2159 2.59664 9.21793 2.5945 9.21984C2.48968 9.32473 2.4183 9.45834 2.38939 9.60378C2.36048 9.74922 2.37533 9.89996 2.43207 10.037C2.48881 10.174 2.58488 10.2911 2.70816 10.3735C2.83143 10.4559 2.97637 10.4999 3.12465 10.5H9.87465C10.023 10.5 10.168 10.4561 10.2913 10.3737C10.4147 10.2913 10.5108 10.1742 10.5676 10.0372C10.6244 9.90016 10.6393 9.74938 10.6104 9.60389C10.5815 9.45841 10.5101 9.32476 10.4053 9.21984C10.403 9.21795 10.4008 9.21591 10.3987 9.21375ZM7.91575 7.875H5.08356L6.49965 6.51937L7.91575 7.875ZM9.87465 2.25L6.49965 5.48062L3.12465 2.25H9.87465Z"
        fill="#155DFC"
      />
    </svg>
  );
}
